// src/hooks/useGetDevices.ts

import { IDevice } from "@backend/src/schemas";
import { useAppSelector } from "../app/hooks";
import { skipToken } from "@reduxjs/toolkit/query";
import { openapi } from "../../openapi";
import { selectGetDevicesArgs } from "../DesignTab/designSlice";

const EMPTY_DEVICES: IDevice[] = [];

export function useGetDevices(): IDevice[] {
  const args = useAppSelector(selectGetDevicesArgs);
  const { data } = openapi.usePostMultiplacerDevicesQuery(args ?? skipToken);
  return data ?? EMPTY_DEVICES;
}
